<template>
  <BittsDropdownMenu
    :model-value="selectedValue"
    v-model:is-open="isOpen"
    v-model:search-term="searchTerm"
    :options="menuOptions"
    mode="multi"
    :show-checkbox="false"
    :use-search="true"
    search-placeholder="Search"
    :disabled="disabled"
    @item-click="handleItemClick"
  >
    <template #default="{ isOpen: dropdownIsOpen }">
      <BittsFilterButton
        :disabled="disabled"
        label-text="Filter"
        variant="default"
        :count="count"
        :active="!!count"
        :is-open="dropdownIsOpen"
      />
    </template>

    <template #prefix="{ option }">
      <slot name="prefix" :option="option">
        <BittsAvatar v-if="option.org" :org="option.org" size="x-small" />
        <div v-else-if="option.faIcon" class="flex items-center">
          <FontAwesomeIcon :icon="option.faIcon" class="text-neutral-accent" />
        </div>
      </slot>
    </template>
  </BittsDropdownMenu>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import BittsAvatar from '../BittsAvatar/BittsAvatar.vue';
import BittsDropdownMenu from '../BittsDropdownMenu/BittsDropdownMenu.vue';
import BittsFilterButton from '../BittsFilterButton/BittsFilterButton.vue';

import type { FilterMenuLeaf, FilterMenuNode, FilterProp } from './types';

const props = defineProps<{
  disabled?: boolean;
  options: FilterProp[] | FilterMenuNode[];
  count?: number;
  selectedOptions?: FilterProp[];
}>();

const emit = defineEmits<{
  addFilter: [filter: FilterProp];
}>();

const isOpen = ref(false);
const searchTerm = ref('');

const menuOptions = computed(() => props.options as FilterMenuNode[]);

const selectedValue = computed(() => {
  const selected = props.selectedOptions ?? [];
  return selected.map((opt) => opt.value);
});

// Handle item click - always emit addFilter to open filter configuration
function handleItemClick(option: FilterMenuLeaf) {
  emit('addFilter', option);
  isOpen.value = false;
  searchTerm.value = '';
}
</script>
